module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADASURBVHgBpZOBDYIwFEQLcYBuYN0AN2AURnAD2QQ30A0aJ0EnwA3qnTkTElpq5SeXNtB7vX6KCSFYyJktRQA0QcO/sLqqqgfGF2QhL1hbwDC1xjsF4EFzggjsfgXxSB0TRJ4RNGrucpBPXxLvGugi2HrftGif2WgOa2KLrqG8+lgSt5KE9+ms6+AXX1BRx4S5VUqae8JSu7D7t4jZZ80zwyAQI590tGXkDOTb8anYjNqpmYz6hI76DcpKR7BmQ70By5Ym16D65/MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/release.png
// module id = Bl3U
// module chunks = 36